import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthState = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const resetState = () => {
        setMessage('');
        setLoading(false);
    };

    return {
        loading,
        setLoading,
        message,
        setMessage,
        navigate,
        resetState
    };
}; 